import axios from 'axios';

const LIFERAY_AUTH_TOKEN = window.Liferay.authToken;
const IS_IMPERSONATING = Boolean(window.Liferay.ThemeDisplay.isImpersonated());
const IMPERSONATE_AS_ID = IS_IMPERSONATING ? window.Liferay.ThemeDisplay.getDoAsUserIdEncoded() : false;

const headers = {
    common: {
        'X-Liferay-Auth-Token': LIFERAY_AUTH_TOKEN,
        'x-csrf-token': LIFERAY_AUTH_TOKEN,
    },
    post: {
        'x-csrf-token': LIFERAY_AUTH_TOKEN,
    },
};

if (IS_IMPERSONATING === true) {
    headers.common['X-Liferay-Impersonate-As'] = encodeURIComponent(IMPERSONATE_AS_ID);
}

const instance = axios.create({
    headers,
});

export default instance;
